import React, { useState, useEffect } from "react";
import { usePDF } from 'react-to-pdf';
import Header from "../../../Components/Header";
import Seo from "../../../Components/SeoComponent/Seo";
import { showSuccessToast, showErrorToast } from "../../../utils/toastUtils";
import { fetchProfile } from "../../../Services/ApiTestService/aadharTestService";
import { verifyRC } from "../../../Services/ApiTestService/apiTestService";
import { InputWithLabel, Button } from "../../../Components/Tags/Tags";
import Loader from "../../../Loader";
import { Link } from "react-router-dom";
import { IoArrowBackCircleOutline } from "react-icons/io5";
import { useService } from "../../../context/ServiceContext";

const RCVerify = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [rcData, setRcData] = useState({});
  const [errors, setErrors] = useState({});
  const [profileData, setProfileData] = useState({});
  const [rcNumber, setRcNumber] = useState("");
  const [showDownloadButton, setShowDownloadButton] = useState(false)
  const { serviceName } = useService();
  const [isPdf , setIsPdf] = useState(false);
  const { toPDF, targetRef } = usePDF({ filename: 'page.pdf' });



  // Fetch profile data on mount
  useEffect(() => {
    const fetchProfileData = async () => {
      try {
        setIsLoading(true);
        const response = await fetchProfile();
        setProfileData(response.data);
      } catch (error) {
        console.error("Error fetching profile data:", error);
        showErrorToast("Failed to fetch profile data.");
      } finally {
        setIsLoading(false);
      }
    };

    fetchProfileData();
  }, []);


  const validateForm = (rcNumber) => {
    const errors = {};
    if (!rcNumber.trim()) {
      errors.rcNumber = "RC number is required.";
    }
    return errors;
  };



  const handleSubmit = async () => {
    const validationErrors = validateForm(rcNumber);
    setErrors(validationErrors);
    if (Object.keys(validationErrors).length > 0) return;

    try {
      setIsLoading(true);

      const response = await verifyRC({
        api_id: profileData?.user_id,
        api_key: profileData?.api_key,
        token_id: profileData?.token_id,
        rc_number: rcNumber,
      });

      const statusCode = response?.status?.code || response?.status;

      if (statusCode === 200) {
        const rcData = response?.data;


        // ✅ Check if valid object or array
        if (rcData && (typeof rcData === "object" || Array.isArray(rcData))) {
          setRcData(rcData);
          showSuccessToast(response.status?.message || "RC Verified successfully.");

          // Clear form
          setRcNumber("");
          setShowDownloadButton(true);
          setErrors({});
        } else {
          showErrorToast("RC No. are missing or in an unexpected format.");
        }
      } else if (statusCode === 422) {
        const backendErrors = response.data.message || {};
        showErrorToast("error", backendErrors);

        showErrorToast(response.data.message || "Invalid format or data.");
      } else if (statusCode === 500) {
        const errorMessage = response.data.message || response?.message || "Server error occurred";
        showErrorToast(errorMessage);
      }
      else {

        showErrorToast(response.status?.message || response.message || response.data.message || response.error.message || `Something went wrong. (code: ${statusCode})`);
      }
    } catch (error) {
      console.error("GST Details Error:", error);
      showErrorToast("Failed to verify Mobile  details. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Seo />
      {isLoading && <Loader />}
      <Header heading={serviceName} />

      <div className="grid grid-cols-2 md:grid-cols-4 gap-2 justify-center md:ml-80 ml-0 p-4">

        <div className="col-span-2 md:col-span-6 flex justify-end">
          <Link
            to="/TestMaster"
            className="flex items-center gap-1 text-white bg-green-600 hover:bg-green-700 px-1 py-1 rounded-md font-semibold shadow-md transition duration-300"
          >
            <span>Go Back</span>
            <IoArrowBackCircleOutline size={24} />
          </Link>
        </div>



        <InputWithLabel
          type="text"
          label="RC Number"
          placeholder="Enter RC No"
          maxLength="10"
          className="p-1 rounded shadow-lg shadow-blue-500/50 border border-blue-600"
          name="rc_number"
          id="rc_number"
          required={true}
          value={rcNumber}
          onChange={(e) => setRcNumber(e.target.value)}
          error={errors.rcNumber}
        />

        <div>
          <Button
            type="button"
            className="text-center text-white bg-blue-900 shadow-lg bg-gradient-to-r from-blue-400 via-blue-1200 to-blue-900 font-semibold rounded-md px-2 py-1 mt-5 text-md hover:from-blue-900 hover:to-blue-400 border-4 ms-2"
            id="verifyRC"
            name="verifyRC"
            text="Verify"
            onClick={handleSubmit}
          />
        </div>

        {
          showDownloadButton && (
            <div>
              <Button
                type={"button"}
                className="text-center text-white bg-blue-900 shadow-lg bg-gradient-to-r from-blue-400 via-blue-1200 to-blue-900 font-semibold rounded-md px-2 py-1 mt-5 text-ms hover:from-blue-900 hover:to-blue-400 border-4 ms-2"
                id='downloadPdf'
                name='downloadPdf'
                text='Download Pdf'
                onClick={() =>{ 
                  setIsPdf(true);
                  setTimeout(() => {
                    toPDF();
                    setIsPdf(false);
                  },300)
                }}
              />
            </div>
          )
        }
      </div>


      {rcData &&
        typeof rcData === "object" &&
        rcData.owner_name &&
        rcData.rc_number && (
          <>
            <div ref={targetRef} className="p-4">
              <h1 className={`${isPdf ? 'text-center text-2xl mb-8 font-semibold text-red-500' : 'hidden'}`}>RC Details for {rcData.owner_name}</h1>
              <div className={`${isPdf ? 'grid print:grid-cols-1 grid-cols-1 sm:grid-cols-1 lg:grid-cols-1 xl:grid-cols-1 gap-4 px-4' : 'grid  grid-cols-2 sm:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 gap-4 px-4'}`}>
                {/* Personal Details Card */}
                <div className="bg-gradient-to-br from-blue-50 to-white border border-blue-200 rounded-2xl shadow-xl p-3 hover:shadow-2xl transition duration-300">
                  <h3 className="text-blue-800 font-semibold text-xl">Personal Details</h3>
                  <div className="text-sm text-gray-700">
                    <p><strong>Owner Name:</strong> {rcData.owner_name}</p>
                    <p><strong>Father's Name:</strong> {rcData.father_name}</p>
                    <p><strong>Mobile Number:</strong> {rcData.mobile_number}</p>
                    <p><strong>Present Address:</strong> {rcData.present_address || "Not Provided"}</p>
                    <p><strong>Permanent Address:</strong> {rcData.permanent_address || "Not Provided"}</p>
                  </div>
                </div>


                {/* Vehicle Specifications Card */}
                <div className="bg-gradient-to-br  from-blue-50 to-white border border-blue-200 rounded-2xl shadow-xl p-3 hover:shadow-2xl transition duration-300">

                  <h3 className="text-blue-800 font-semibold text-xl">Vehicle Specifications</h3>
                  <div className="text-sm text-gray-700">
                    <p><strong>Cubic Capacity:</strong> {rcData.cubic_capacity} cc</p>
                    <p><strong>Seat Capacity:</strong> {rcData.seat_capacity} seats</p>
                    <p><strong>Wheelbase:</strong> {rcData.wheelbase} mm</p>
                    <p><strong>Unladen Weight:</strong> {rcData.unladen_weight} kg</p>
                    <p><strong>Vehicle Gross Weight:</strong> {rcData.vehicle_gross_weight} kg</p>
                    <p><strong>No. of Cylinders:</strong> {rcData.no_cylinders}</p>
                  </div>
                </div>



                {/* Tax & PUCC Details Card */}
                <div className="bg-gradient-to-br from-blue-50 to-white border border-blue-200 rounded-2xl shadow-xl p-3 hover:shadow-2xl transition duration-300">
                  <h3 className="text-blue-800 font-semibold text-xl">Tax & PUCC Details</h3>
                  <div className="text-sm text-gray-700">
                    <p><strong>Tax Upto:</strong> {rcData.tax_upto}</p>
                    <p><strong>Tax Paid Upto:</strong> {rcData.tax_paid_upto}</p>
                    <p><strong>PUCC Number:</strong> {rcData.pucc_number}</p>
                    <p><strong>PUCC Validity Upto:</strong> {rcData.pucc_upto}</p>
                  </div>
                  <h3 className="text-blue-800 font-semibold text-xl">insurance Details</h3>
                  <div className="text-sm text-gray-700">
                    <p><strong>Insurance Company:</strong> {rcData.insurance_company}</p>
                    <p><strong>Insurance Policy Number:</strong> {rcData.insurance_policy_number}</p>
                    <p><strong>Insurance Upto:</strong> {rcData.insurance_upto}</p>
                    <p><strong>Registered At:</strong> {rcData.registered_at}</p>
                  </div>
                </div>

                {/* JSON Preview Card */}
                {
                  isPdf && (
                  <div className='bg-gradient-to-br from-blue-50 to-white border border-blue-200 rounded-2xl shadow-xl p-2 hover:shadow-2xl transition duration-300'>
                    <h2 className="text-lg font-semibold text-blue-800 mb-1">RC JSON Data</h2>
                    <pre className="bg-gray-100 p-1 rounded text-sm overflow-y-auto max-h-[200px]"> {/* Fixed height set here */}
                      {JSON.stringify(rcData, null, 2)}
                    </pre>
                  </div>
                  )
                }
              </div>
            </div>
          </>

        )}



    </>
  );
};

export default RCVerify;
